import { names } from './Actions';
import { Store } from "../../../../flux/Store";

export class SearchFormStore extends Store<any>
{
    constructor() {
        super();
        this.state = {};

        this.register<any>(names.SEARCH_PARAMS_UPDATED, e => {
            if(e.meta === this.dispatchToken) {
                return {...e.payload};
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Search/Store.ts